import { CountryEnv } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_TW_UQ || "uqtw-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_TW_UQ || 26494,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_TW_UQ || 26499,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_TW_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_TW_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_TW_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_TW_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  faqUrl: "https://faq-tw.uniqlo.com/",
  showAboutApp: true
};

export default _countryEnv;
